import { apiClient } from '../../services/api';
import { createClientRequestId } from '../../utils/clientRequestId';

const HEADERS = { 'X-Portal': 'business' };
const BASE = '/api/business/delivery/cod';

function unwrap(response) {
  return response?.data?.data ?? response?.data ?? response;
}

export const businessCodService = Object.freeze({
  async list(businessId, filters = {}) {
    const response = await apiClient.get(BASE, {
      headers: HEADERS,
      params: { businessId, ...(filters.status ? { status: filters.status } : {}) },
    });
    return unwrap(response);
  },
  async get(businessId, recordId) {
    const response = await apiClient.get(`${BASE}/${recordId}`, { headers: HEADERS, params: { businessId } });
    return unwrap(response);
  },
  async remit(businessId, recordId, payload) {
    const response = await apiClient.post(`${BASE}/${recordId}/remit`, { businessId, ...payload }, {
      headers: { ...HEADERS, 'Idempotency-Key': payload.idempotencyKey || createClientRequestId('cod_remit') },
    });
    return unwrap(response);
  },
  async reconcile(businessId, recordId, payload) {
    const response = await apiClient.post(`${BASE}/${recordId}/reconcile`, { businessId, ...payload }, {
      headers: { ...HEADERS, 'Idempotency-Key': payload.idempotencyKey || createClientRequestId('cod_reconcile') },
    });
    return unwrap(response);
  },
  async resolveDiscrepancy(businessId, recordId, payload) {
    const response = await apiClient.post(`${BASE}/${recordId}/discrepancies`, { businessId, ...payload }, {
      headers: { ...HEADERS, 'Idempotency-Key': payload.idempotencyKey || createClientRequestId('cod_discrepancy') },
    });
    return unwrap(response);
  },
});
